// STYLE 
import './_author.scss';

// LIBS
import React from 'react'
import {get, map} from 'lodash/fp'

// COMPONENTS
import MetaData from '../../components/meta-data'

// INTERFACE
export const query = graphql`
  query BlogAuthorsQuery {
    allAuthorJson {
      edges {
        node {
          name
          slug
        }
      }
    }
  }
`;

export default ({data}) => {
  let authors = map(get('node'), get('allAuthorJson.edges', data))
  return (
    <div className='author' style={{paddingTop: '80px', textAlign: 'center'}}> 
      <MetaData data={{
        slug: 'blog/author',
        title: 'Blog Authors',
        description: 'Code Fellows blog authors',
      }}/>
      <h2> Blog Authors </h2>
      {authors.map((author, i) => {
        let image = get('image.fields.file.url', author)
        return (
          <div key={i}>
            <a href={'/' + author.slug}>{author.name}</a>
          </div>
        )
      })}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/author/index.js